import { render, staticRenderFns } from "./ertesitesListSkeleton.vue?vue&type=template&id=3c4f66c4&"
import script from "./ertesitesListSkeleton.vue?vue&type=script&lang=js&"
export * from "./ertesitesListSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports